import { render } from "./AgreeModalComp.vue?vue&type=template&id=fdca83ba&ts=true"
import script from "./AgreeModalComp.vue?vue&type=script&lang=ts"
export * from "./AgreeModalComp.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__